<div class="bottom-sheet-overlay" (click)="closePopup()">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="header">
      <div class="header-content">
        <app-back-button ariaLabel="Close" (clicked)="closePopup()"></app-back-button>
        <h2 class="title">New Members</h2>
        <app-confirm-button 
          ariaLabel="Save" 
          [loading]="isSaving" 
          [disabled]="isSaving || selectedMembers.length === 0"
          (clicked)="save()">
        </app-confirm-button>
      </div>
    </div>

    <!-- Tabs/Segmented Control -->
    <div class="tabs-container">
      <div class="segmented-control">
        <button [class.active]="activeTab === 'send'" (click)="setTab('send')">
          Send
        </button>
        <button [class.active]="activeTab === 'pending'" (click)="setTab('pending')">
          Pending
        </button>
        <button [class.active]="activeTab === 'requests'" (click)="setTab('requests')">
          Requests
        </button>
      </div>
    </div>

    <div class="content-scrollable">
      <!-- SEND TAB -->
      <div *ngIf="activeTab === 'send'">
        <!-- Invite Members Section (only show when members are selected) -->
        <div class="form-group" *ngIf="selectedMembers.length > 0">
          <label>Invite Members</label>
          <div class="chips-input-container">
            <div class="chips-row">
              <div class="member-chip" *ngFor="let member of selectedMembers">
                <span>{{ member.name }}</span>
                <app-exit-button variant="danger" ariaLabel="Remove member"
                  (clicked)="removeMember(member)"></app-exit-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Search Bar -->
        <div class="search-section">
          <div class="search-input-container">
            <img src="assets/common_icons/search_icon.svg" class="search-icon" alt="Search" />
            <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange($event)"
              placeholder="Search Users To Invite" />
          </div>
        </div>

        <!-- Search Hint (only when user typed exactly 1 character) -->
        <div class="search-hint" *ngIf="!isLoading && searchQuery.length === 1 && suggestedMembers.length === 0">
          <p>Type at least 2 characters to search</p>
        </div>

        <!-- Search Results Section -->
        <div class="suggested-section" *ngIf="suggestedMembers.length > 0 || (searchQuery.length >= 2 && !isLoading)">
          <h3 class="section-title" *ngIf="suggestedMembers.length > 0">Search Results ({{ suggestedMembers.length }})
          </h3>

          <!-- Loading State -->
          <div class="loading-state" *ngIf="isLoading">
            <p>Searching members...</p>
          </div>

          <!-- Empty State -->
          <div class="empty-state" *ngIf="!isLoading && searchQuery.length >= 2 && suggestedMembers.length === 0">
            <p>No members found for "{{ searchQuery }}"</p>
          </div>

          <div class="suggested-list">
            <div class="suggested-item" *ngFor="let member of suggestedMembers" (click)="toggleMemberSelection(member)">
              <div class="checkbox-container">
                <input type="checkbox" [checked]="member.selected" (change)="
                    $event.stopPropagation(); toggleMemberSelection(member)
                  " />
                <span class="checkmark"></span>
              </div>
              <div class="member-avatar">
                <img [src]="member.image" alt="Avatar" *ngIf="member.image" />
                <div class="initials-avatar" *ngIf="!member.image">
                  {{ member.initials }}
                </div>
              </div>
              <span class="member-name">{{ member.name }}</span>
            </div>
          </div>
        </div>

        <!-- Message Section -->
        <div class="form-group message-group">
          <label>Message</label>
          <p class="subtitle">This message will appear in the invitation</p>
          <textarea [(ngModel)]="invitationMessage" placeholder="Enter Message"></textarea>
        </div>
      </div>

      <!-- PENDING TAB -->
      <div *ngIf="activeTab === 'pending'">
        <div class="invites-list">
          <div class="pending-card" *ngFor="let invite of pendingInvites">
            <div class="pending-header">
              <div class="member-avatar">
                <img [src]="invite.image" alt="Avatar" *ngIf="invite.image" />
                <div class="initials-avatar" *ngIf="!invite.image">
                  {{ invite.initials }}
                </div>
              </div>
              <div class="pending-info">
                <div class="name-row">
                  <span class="name">{{ invite.name }}</span>
                  <span class="time">{{ invite.time }}</span>
                </div>
                <span class="status-text">Invitation pending</span>
              </div>
            </div>
            <button class="cancel-btn" (click)="cancelInvite(invite.id)">Cancel</button>
          </div>
        </div>
        <div class="empty-state-centered" *ngIf="!isLoading && pendingInvites.length === 0">
          <p>No pending invitations</p>
        </div>
      </div>

      <!-- REQUESTS TAB -->
      <div *ngIf="activeTab === 'requests'">
        <div class="invites-list" *ngIf="joinRequests.length > 0">
          <div class="invite-card" *ngFor="let req of joinRequests">
            <div class="invite-header">
              <div class="member-avatar">
                <img [src]="req.image" alt="Avatar" *ngIf="req.image" />
                <div class="initials-avatar" *ngIf="!req.image">
                  {{ req.initials }}
                </div>
              </div>
              <div class="invite-info">
                <div class="name-row">
                  <span class="name">{{ req.name }}</span>
                  <span class="time">{{ req.time }}</span>
                </div>
                <div class="tag">
                  <img src="assets/home/profile/boaticon.svg" alt="Tag" />
                  {{ req.group }}
                </div>
              </div>
            </div>
            <div class="invite-actions">
              <button class="decline-btn" (click)="respondToJoinRequest(req.id, 'ignored')">Decline</button>
              <button class="accept-btn" (click)="respondToJoinRequest(req.id, 'accepted')">Accept</button>
            </div>
          </div>
        </div>
        <div class="empty-state-centered" *ngIf="!isLoading && joinRequests.length === 0">
          <div class="empty-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
              stroke="#c7c7cc" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M7 15h0M12 15h0M17 15h0" />
              <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
          </div>
          <p class="empty-title">No join requests</p>
          <p class="empty-subtitle">Requests to join your fleets will appear here</p>
        </div>
      </div>
    </div>
  </div>
</div>